import {
  LogEvent,
  LogEventFailure,
  LogEventSuccess,
  SetUserIdSuccess,
} from "./actionTypes";
import {
  AMPLITUDE_LOG_EVENT,
  AMPLITUDE_LOG_EVENT_FAILURE,
  AMPLITUDE_LOG_EVENT_SUCCESS,
  AMPLITUDE_SET_USER_ID_SUCCESS,
} from "./constants";

import { IBookInfo } from "../library/IBookInfo";

import { AppEvents, BookEvents } from "../../../api/amplitude/AmplitudeEvents";
import {
  BookCreatedProperties,
  BookFailedProperties,
} from "../../../api/amplitude/types";

export function appLaunched(): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: AppEvents.APP_LAUNCHED,
    },
  });
}

export function appOpened(): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: AppEvents.APP_OPENED,
    },
  });
}

export function bookCompleteListening({ id, title, wordCount }: IBookInfo): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: BookEvents.BOOK_COMPLETED,
      data: {
        book_id: id,
        book_title: title,
        book_num_words: wordCount,
      },
    }
  });
}

export function bookCreated({ data }: BookCreatedProperties): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: BookEvents.BOOK_CREATED,
      data: {
        ...data,
        book_create_pathway: "web",
      },
    },
  });
}

export function bookFailed({ data }: BookFailedProperties): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: BookEvents.BOOK_FAILED,
      data: {
        ...data,
        book_create_pathway: "web",
      },
    },
  });
}

export function bookStartListening({ id, title, wordCount }: IBookInfo): LogEvent {
  return ({
    type: AMPLITUDE_LOG_EVENT,
    payload: {
      event: BookEvents.BOOK_STARTED,
      data: {
        book_id: id,
        book_title: title,
        book_num_words: wordCount,
      },
    },
  });
}

// will be used in future
export function logEventFailure(): LogEventFailure {
  return ({
    type: AMPLITUDE_LOG_EVENT_FAILURE,
  });
}

export function logEventSuccess(): LogEventSuccess {
  return ({
    type: AMPLITUDE_LOG_EVENT_SUCCESS,
  });
}

export function setUserIdSuccess(): SetUserIdSuccess {
  return ({
    type: AMPLITUDE_SET_USER_ID_SUCCESS,
  });
}
